// React
import { useTheme } from '@emotion/react';
import { Button, Grid, Typography } from '@mui/material';
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';
import { isRenault } from '../../util/constants';

// MUI


export default function CustomMarker({ setDealer, dealer, ...rest }) {
  const { t } = useTranslation();
  const theme = useTheme()

  const styles = {

    button: {
      backgroundColor: theme.palette.primary.main,
      color: isRenault ? '#000' : '#fff',
      '&:hover': {
        backgroundColor: isRenault ? '#A79C00' : '#464a39',
      }
    }
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: 'bold' }}  >
          {dealer.shortName}
        </Typography>
        <br />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body2'>
          {dealer.address}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body2'>
          {dealer.city} / {dealer.district}
        </Typography>
      </Grid>
      {dealer.distance ? <Grid item xs={12}>
        <Typography variant='body2'>
          Konuma olan uzaklığınız: <Typography fontWeight={'bold'} display='inline'>{(dealer.distance / 1000).toFixed(1)} Km.</Typography>
        </Typography>
      </Grid>
        : null
      }
      <Grid container justifyContent="flex-end" pt={2} >
        <Button variant="outlined" sx={styles.button} style={{ minWidth: '105px' }} onClick={() => setDealer(dealer)}>
          {t('chooseService')}
        </Button>
      </Grid>
    </Grid>
  );
}
